import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingPage() {
  return (
    <CircularProgress
      size={64}
      sx={{ display: "flex", alignSelf: "center", justifySelf: "center", margin: '32px 0' }}
    />
  );
}
